<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div style="width: 500px;">
        <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
          <el-form-item label="活动名称">
            <el-input v-model="ruleForm.name" disabled />
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker
              v-model="ruleForm.activityTime"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              disabled
            />
          </el-form-item>
          <el-form-item label="活动说明">
            <el-input v-model="ruleForm.description" type="textarea" :rows="4" disabled />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" label-width="100px">
          <el-card v-for="(items,indexs) in configForm.coupons" :key="indexs" class="level-config">
            <div slot="header">
              <span>{{ numberfilter(indexs+1) }}级配置</span>
            </div>
            <el-form-item label="充值金额">
              <el-input v-model="items.amount" disabled><template slot="append">元</template></el-input>
            </el-form-item>
            <template v-for="(row,index) in items.coupons">
              <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)">
                <div class="d-flex">
                  <el-select v-model="row.couponId" style="width: 200px;" disabled>
                    <el-option
                      v-for="item in allCoupon"
                      :key="item.couponId"
                      :label="item.couponName"
                      :value="item.couponId"
                    />
                  </el-select>
                  <el-input v-model="row.count" class="ml-20" style="width: 100px;" disabled />
                  <div class="ml-20">张</div>
                </div>
              </el-form-item>
            </template>
          </el-card>

          <el-form-item label="可参与次数">
            <el-input v-model="configForm.times" disabled />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" label-width="100px">
          <el-form-item label="可参与用户">
            <el-radio-group v-model="partakeForm.userType">
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id" disabled>{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.mechanism"
                :props="treeDefaultProps"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.tag"
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户参与记录</span>
      </div>
      <STable
        ref="detailTableref"
        :url="detailUrl"
        :columns="detailColumns"
        :query="detailQuery"
        :selection="false"
        :toolbar="detailToolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import {
  numberfilter
} from '@/utils/tool'
import {
  HOST
} from '@/utils/host'
import { treeDisabled } from '@/utils/tool'
export default {
  props: {
    // 表单信息数据
    // formData: {
    //   type: Object,
    //   default() {
    //     return {

    //     }
    //   }
    // },
    // // 预留的id，通过id查询详情信息
    // id: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      ruleForm: {
        name: '', // 活动名称
        activityTime: [], // 活动时间
        description: '' // 活动说明
      },
      // 所有的优惠券数据
      allCoupon: [],
      configForm: {
        coupons: [{
          amount: '', // 消费金额(充电电量) 表示达到多少
          coupons: [{
            couponId: '', // 选择的优惠券
            count: '' // 数量
          }]
        }],
        times: ''
      },
      // 可参与用户字段的单选数据
      userTypeItem: [{
        label: '全部用户',
        id: '1'
      }, {
        label: '选择企业',
        id: '2'
      }, {
        label: '选择标签',
        id: '3'
      }],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        userType: '1', // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      }, // 详情页的表格数据
      detailUrl: '/activity/pageParticipation',
      detailColumns: [{
        label: '所属企业',
        prop: 'orgName'
      },
      {
        label: '用户账号',
        prop: 'loginName'
      },
      {
        label: '用户姓名',
        prop: 'userName'
      },
      {
        label: '手机号',
        prop: 'mobile'
      },
      {
        label: '奖励梯度',
        prop: 'level',
          template: function(index, record) {
          if (record.level === '1') {
            return '一级'
          } else if (record.level === '2') {
            return '二级'
          } else if (record.level === '3') {
            return '三级'
          }
                     else if (record.level === '4') {
            return '四级'
          } else if (record.level === '5') {
            return '五级'
          } else if (record.level === '6') {
            return '六级'
          } else if (record.level === '7') {
            return '七级'
          } else if (record.level === '8') {
            return '八级'
          } else if (record.level === '9') {
            return '九级'
          }
           else if (record.level === '10') {
            return '十级'
          }
        }    
      },
            {
        label: '充值金额',
        prop: 'amount'
      },
      {
        label: '充值时间',
        prop: 'createTime'
      }
      ],
      detailQuery: [{
        label: '所属企业',
        prop: 'orgName',
        placeholder: '请输入企业名称'
        // type: 'select3',
        // data: [],
        // remoteMethod: (val) => {
        //   this.loadMechanism(val)
        // }
      }, {
        label: '用户账号',
        prop: 'loginName',
        placeholder: '请输入用户账号'
      }, {
        label: '手机号',
        prop: 'mobile',
        placeholder: '请输入手机号'
      }, {
        label: '充值时间',
        prop: 'createTime',
        placeholder: '',
        type: 'date2'
      }, {
        label: '参与次数',
        prop: 'times',
        placeholder: '请输入参与次数'
      }],
      detailToolbar: [{
        label: '导出',
        icon: 'el-icon-download',
        type: 'primary',
        handle: (index, record) => {
          const url = HOST + '/activity/exportParticipation?activityId=' + this.id
          const data = this.$refs.detailTableref.getQueryData()
          $.fileDownload(url, {
            httpMethod: 'GET',
            data: {
              token: window.localStorage.getItem('token'),
              ...data
            },
            failCallback: (html, url) => {
              this.$notify({
                title: '失败',
                message: '导出用户参与记录失败',
                type: 'error'
              })
            }
          })
        }
      }]
    }
  },
  beforeMount() {
    this.id=this.$route.query.id
    this.detailUrl = '/activity/pageParticipation?activityId=' + this.id
  },
  mounted() {


     this.formData=JSON.parse(decodeURIComponent(this.$route.query.infoForm))


    // 接收数据后回显赋值
    this.$nextTick(() => {
      console.log('接收到的数据', this.formData)
      this.ruleForm = JSON.parse(JSON.stringify(this.formData.ruleForm))
      this.configForm = JSON.parse(JSON.stringify(this.formData.configForm))
      const newpartakeForm = JSON.parse(JSON.stringify(this.formData.partakeForm))
      this.partakeForm.userType = newpartakeForm.userType
      if (newpartakeForm.userType === '2') {
        this.partakeForm.mechanism = newpartakeForm.userValue.split(',')
        this.partakeForm.tag = []
        this.loadTree2()
      } else if (newpartakeForm.userType === '3') {
        this.partakeForm.mechanism = []
        this.partakeForm.tag = newpartakeForm.userValue.split(',')
        this.loadTree3()
      }
      // 加载优惠券数据
      this.loadCoupon()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载企业数据
    loadMechanism(val) {
      const data = {
        name: val,
        pageNo: 1,
        pageSize: 100
      }
      this.$store.dispatch('form/handle', {
        url: '/org/page',
        data: data,
        callback: resp => {
          this.detailQuery[0].data = resp.list
        }
      })
    },
    // 加载全部企业数据
    loadTree2() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
      this.$forceUpdate()
    },
    // 加载全部标签数据
    loadTree3() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
      this.$forceUpdate()
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    cancel() {
      // this.$emit('backHome')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex {
    display: flex;
  }

  .ml-20 {
    margin-left: 20px;
  }

  .icon-jia {
    font-size: 22px;
    align-items: center;
    display: flex;
  }

  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }

  /deep/ .el-card.level-config {
    margin: 10px 0;

    .el-card__header {
      font-size: 16px;
      padding: 10px 15px;
    }

    .el-card__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/rechargeDetail.vue